import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {faTriangleExclamation, faXmark, faChevronRight, faPlus} from "@fortawesome/free-solid-svg-icons";
import {SystemManagementService} from "../../../data-access/system-management.service";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MenuItem} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface Item {
  name: string,
  organization_id: number
  items: MenuItem[]
}
@Component({
    selector: 'organization-list',
    templateUrl: './organization-list.component.html',
    standalone: false
})
export class OrganizationListComponent implements OnInit {
  router = inject(Router)
  systemService = inject(SystemManagementService)
  _snackBar = inject(MatSnackBar)
  currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  items: Item[] = []
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }, {
    text: 'System Lists',
    route: 'dashboard/SystemManagement/lists'
  }]

  ngOnInit() {
    this.handleServiceCall()
  }

  handleServiceCall() {
    this.systemService.listOrgs(this.currentPagination.limit, this.currentPagination.page).subscribe((response) => {
      if(response.success) {
        this.items = []
        for(let item of response.result.items) {
          this.items.push({
            ...item,
            items: [{
              title: 'Edit',
              route: 'dashboard/SystemManagement/organizations/config',
              queryParams: {queryParams: {organization_id: item.organization_id, name: item.name}}
            }]
          })
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  orgConfig() {
    // TODO add url param for edit
    this.router.navigate(['dashboard/SystemManagement/organizations/config'])
  }

  protected readonly faPlus = faPlus;
}
